import { isAxiosError } from "axios";

/** Human-readable message for failed API calls (login, password reset, etc.). */
export function messageFromUnknownHttpError(error: unknown): string {
  if (!isAxiosError(error)) {
    if (error instanceof Error && error.message) {
      return error.message;
    }
    return "Something went wrong. Please try again.";
  }

  if (error.code === "ERR_NETWORK" || !error.response) {
    return "Cannot reach the server. Check your connection and confirm the API is running.";
  }

  const status = error.response.status;
  const data = error.response.data as unknown;
  let detailRaw: unknown;

  if (data && typeof data === "object" && "detail" in data) {
    detailRaw = (data as { detail: unknown }).detail;
  }

  if (typeof detailRaw === "string" && detailRaw.trim()) {
    return detailRaw.trim();
  }

  if (Array.isArray(detailRaw) && detailRaw.length > 0) {
    const first = detailRaw[0];
    if (first && typeof first === "object" && "msg" in first && typeof (first as { msg: unknown }).msg === "string") {
      return (first as { msg: string }).msg;
    }
  }

  if (status === 401) {
    return "Incorrect email or password, or this account does not exist in the provisioning portal.";
  }
  if (status === 403) {
    return "You are not allowed to sign in.";
  }
  if (status === 429) {
    return "Too many sign-in attempts. Please wait and try again.";
  }
  if (status >= 500) {
    return "Server error. Please try again in a moment.";
  }

  return `Sign-in failed (${status}).`;
}
